<template>
  <div class="feature">
    <div class="module">
      <div class="title"></div>
      <div class="content">
        <div class="swiper" id="featureSwiper">
          <div class="swiper-wrapper">
            <div v-for="(url, key) in list" :key="key" class="swiper-slide">
              <img :src="url" />
            </div>
          </div>
          <div class="swiper-navigation swiper-button__prev"></div>
          <div class="swiper-navigation swiper-button__next"></div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.mjs'
import 'swiper/swiper-bundle.css'

export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      featureList: [],
    }
  },
  watch: {
    list: function (val) {
      this.initSwiper()
    }
  },
  methods: {
    // 初始化轮播图
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('#featureSwiper', {
          direction: 'horizontal',
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          slidesPerView: 1.242522,
          centeredSlides: true,
          effect: "coverflow",
          coverflowEffect: {
            rotate: 0,
            stretch: 1042,
            depth: 150,
            modifier: 1,
            slideShadows: false,
          },
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'swiper-pagination__btn',
            bulletActiveClass: 'swiper-pagination--active',
            clickable: true,
            renderBullet: function (index, className) {
              return '<div class="' + className + '"></div>'
            }
          },
          navigation: {
            prevEl: '.swiper-button__prev',
            nextEl: '.swiper-button__next',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.feature {
  width: 100%;
  height: 1210px;
  background: url('~@/assets/img/bg_module3.jpg') no-repeat;
  background-position: center;
}

.module {
  padding-top: 92px;
}

.title {
  background-position: 0 -310px;
}

.content {
  margin-top: 48px;
}

.swiper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1537px;
  height: 816px;

  .swiper-slide {
    position: relative;
    opacity: 0;
    width: 1237px;
    height: 719px;
    background: url('~@/assets/img/bg_feature.png') no-repeat;

    ::v-deep img {
      margin: 25px 0 0 27px;
      width: 1185px;
      height: 666px;
    }
  }

  .swiper-slide-next,
  .swiper-slide-prev,
  .swiper-slide-active {
    opacity: 1;
  }

  .swiper-slide-next,
  .swiper-slide-prev {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      z-index: 1;
      margin: 10px;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      background: #000;
      opacity: 0.5;
    }
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;

    ::v-deep .swiper-pagination__btn {
      display: block;
      margin: 0 10px;
      width: 42px;
      height: 37px;
      background: url('~@/assets/img/feature_swiper.png') no-repeat;
      background-position: -42px 0;
      cursor: pointer;
    }

    ::v-deep .swiper-pagination--active {
      background-position: 0;
    }
  }

  .swiper-navigation {
    position: absolute;
    z-index: 1;
    top: 338px;
    width: 64px;
    height: 94px;
    background: url('~@/assets/img/arrow.png') no-repeat;
    cursor: pointer;

    &.swiper-button__prev {
      left: 75px;
    }

    &.swiper-button__next {
      right: 75px;
      background-position: -64px 0;
    }
  }
}
</style>